

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
  mode: process.env.NODE_ENV == 'development' ? 'hash' : 'history',
  base: "720",
  routes: [{
      path: '/',
      name: 'index',
      meta: {
        category_id: 1,
        title: '鸟瞰',
      },
      component: () => import('@/pages/index/index')
    }, {
      path: '/qwys',
      name: 'qwys',
      meta: {
        category_id: 2,
        title: '区位',
      },
      component: () => import('@/pages/index/qwys')
    }, {
      path: '/fzlc',
      name: 'fzlc',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/fzlc')
    }, {
      path: '/jtjs',
      name: 'jtjs',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/jtjs')
    }, {
      path: '/xmzs',
      name: 'xmzs',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/xmzs')
    }, {
      path: '/huxing',
      name: 'huxing',
      meta: {
        category_id: 2,
        title: '户型-樾',
        // keepAlive: true
      },
      component: () => import('@/pages/index/huxing')
    }, {
      path: '/huxing1',
      name: 'huxing1',
      meta: {
        category_id: 2,
        title: '户型-归',
        // keepAlive: true
      },
      component: () => import('@/pages/index/huxing1')
    }, {
      path: '/huxing2',
      name: 'huxing2',
      meta: {
        category_id: 2,
        title: '户型-鹿',
        // keepAlive: true
      },
      component: () => import('@/pages/index/huxing2')
    }, {
      path: '/huxing3',
      name: 'huxing3',
      meta: {
        category_id: 2,
        title: '户型-鹿',
        // keepAlive: true
      },
      component: () => import('@/pages/index/huxing3')
    }, {
      path: '/xmgs',
      name: 'xmgs',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/xmgs')
    },
    {
      path: '/manyou',
      name: 'manyou',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/manyou')
    },
    {
      path: '/manyou1',
      name: 'manyou1',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/manyou1')
    },
    {
      path: '/manyou2',
      name: 'manyou2',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/manyou2')
    },


    {
      path: '/houseA',
      name: 'houseA',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/houseA')
    },
    {
      path: '/houseB',
      name: 'houseB',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/houseB')
    },
    {
      path: '/houseF',
      name: 'houseF',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/houseF')
    },
    {
      path: '/houseF2',
      name: 'houseF2',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/houseF2')
    },
    {
      path: '/houseK',
      name: 'houseK',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/houseK')
    },
    {
      path: '/houseL',
      name: 'houseL',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/houseL')
    },
    {
      path: '/houseM',
      name: 'houseM',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/houseM')
    },
    {
      path: '/csqh',
      name: 'csqh',
      meta: {
        category_id: 2,
        title: '',
      },
      component: () => import('@/pages/index/csqh')
    },


















    {
      path: '/agent/Recommend',
      name: 'Recommend',
      meta: {},
      component: () => import('@/pages/agent/Recommend')
    },
    {
      path: '/agent/myCustom',
      name: 'myCustom',
      component: () => import('@/pages/agent/myCustom')
    },
    {
      path: '/agent/center',
      name: 'center',
      component: () => import('@/pages/agent/center')
    },
    {
      path: '/agent/customDetail',
      name: 'customDetail',
      component: () => import('@/pages/agent/customDetail')
    },
    {
      path: '/agent/sucai',
      name: 'sucai',
      component: () => import('@/pages/agent/sucai')
    },
    {
      path: '/agent/evpi',
      name: 'evpi',
      component: () => import('@/pages/agent/evpi')
    },
    {
      path: '/agent/bankCard',
      name: 'bankCard',
      component: () => import('@/pages/agent/bankCard')
    },
    {
      path: '/agent/tx',
      name: 'tx',
      component: () => import('@/pages/agent/tx')
    },
    {
      path: '/agent/cmsDetail',
      name: 'cmsDetail',
      component: () => import('@/pages/agent/cmsDetail')
    },
    {
      path: '/agent/tousu',
      name: 'tousu',
      component: () => import('@/pages/agent/tousu')
    },
    {
      path: '/agent/xuzhi',
      name: 'xuzhi',
      component: () => import('@/pages/agent/xuzhi')
    }
  ]

})



router.beforeEach((to, from, next) => {
  if (to.path.indexOf('agent') > -1 || to.path.indexOf('ylsp') > -1 || to.path.indexOf('vinfo') > -1) {
    audio.pause()
  }
  next();
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js